import { Box, Tooltip, Typography } from "@mui/material";
import React from "react";

import TruncatedText from "../../full-time-shifts/ui/weekly-shift-view/truncated-text";
import Highlight from "../../Highlight";

interface ColumnEmployeeCellProps {
    params: any;
    searchText?: string;
}

const ColumnEmployeeCell: React.FC<ColumnEmployeeCellProps> = ({
    params,
    searchText,
}) => {
    const fullName = `${params.row.firstName} ${params.row.lastName}`;

    return (
        <TruncatedText
            text={fullName}
            searchedTerm={searchText}
            style={{
                fontFamily: "Roboto",
                fontSize: "14px",
                fontWeight: 400,
                lineHeight: "20px",
                color: "#1C1B1F",
                width: "100%",
                paddingLeft: "16px",
                boxSizing: "border-box",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
            }}
        />
    );
};

export default ColumnEmployeeCell;
